module.exports = __webpack_public_path__ + "img/app2.ec4948ca.jpg";